import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ConfigService } from '../../../config/config.service';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { handleProblem } from '../../problems/problem.service';
import { DamageEventDetailInterface } from '../definitions/damage-event-detail-interface';

@Injectable()
export class DamageEventDetailByIdService {

  public constructor(private client: HttpClient, private configService: ConfigService) {}

  public detail(id: string): Observable<DamageEventDetailInterface> {
    const url = `${this.configService.config.rest.apiV2Url}/damage-events/${id}`;

    return this.client.get<DamageEventDetailInterface>(url).pipe(
      catchError(error => throwError(handleProblem(error)))
    );
  }
}
